import React from 'react';

import { IconProps } from './types';

const PerformanceArrow: React.FC<IconProps> = props => {
  const { className, style, title } = props;
  return (
    // TODO: Use tooltip component instead of title.
    <svg
      style={style}
      className={className}
      width="21"
      height="9"
      viewBox="0 0 21 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 4.5L2.25 8.39711L2.25 0.602885L9 4.5Z" fill="#0094FF" />
      <path d="M20 4.49805L8 4.50179" stroke="#3591FE" strokeLinecap="round" />
    </svg>
  );
};

export default PerformanceArrow;
